<div 
  class="photo-wrapper" 
  [ngClass]="{ editable }"
  [ngStyle]="{'width': width + 'px'}"
  (click)="editable && openFileSelector(fileInput)"
>
  <img [src]="croppedImageFinal || image" alt="image" class="photo" />
  <div class="overlay" *ngIf="editable">{{ 'button.click-change' | translate }}</div>
</div>

<input
  #fileInput
  type="file"
  accept="image/*"
  (change)="fileChangeEvent($event)"
  hidden
/>

<p-dialog
  [header]="'crop-image' | translate"
  [(visible)]="showCropperModal"
  [modal]="true"
  [style]="{ width: '600px', height: 'auto' }"
  [contentStyle]="{ 'overflow': 'visible' }"
>
  <image-cropper
    *ngIf="imageChangedEvent"
    [imageFile]="imageChangedEvent"
    [maintainAspectRatio]="true"
    [aspectRatio]="3 / 4"
    format="png"
    [resizeToWidth]="300"
    style="width: 100%; display: block; margin: auto;"
    (imageCropped)="imageCropped($event)"
    (loadImageFailed)="loadImageFailed()"
  ></image-cropper>

  <ng-template pTemplate="footer">
    <!-- buttons -->
    <div class="buttons">
      <button pButton [label]="'button.cancel' | translate" severity="secondary" (click)="cancel()"></button>
      <button pButton [label]="'button.save' | translate" severity="contrast" (click)="saveCroppedImage()"></button>
    </div>
  </ng-template>
</p-dialog>